const hostEnvMap = {
  localhost: 'dev',
  'dev.smith.langchain.com': 'dev',
  'beta.smith.langchain.com': 'staging',
  'smith.langchain.com': 'prod',
};

export function getCurrentEnv(): string {
  const hostname = window.location.hostname;
  if (hostname in hostEnvMap) {
    return hostEnvMap[hostname];
  } else if (hostname.endsWith('vercel.app')) {
    return 'dev';
  }
  return 'selfhosted';
}
